module.exports = __webpack_public_path__ + "img/restaurant-price_en.be57df35.svg";